
/**
 * Subtle "Offline" indicator shown in the top-right corner when the dashboard
 * cannot reach the API. Non-intrusive overlay with semi-transparent background.
 */
export function ConnectivityIndicator() {
  return (
    <div
      style={{
        position: 'fixed',
        top: 16,
        right: 16,
        padding: '8px 16px',
        borderRadius: 6,
        background: 'rgba(200, 50, 50, 0.75)',
        color: '#ffffff',
        fontSize: '14px',
        fontFamily: "'Inter', system-ui, sans-serif",
        fontWeight: 500,
        letterSpacing: '0.5px',
        zIndex: 9999,
        pointerEvents: 'none',
      }}
    >
      Offline
    </div>
  );
}
